import { render, staticRenderFns } from "./budgets-report.vue?vue&type=template&id=ee3d2c6e"
import script from "./budgets-report.vue?vue&type=script&lang=js"
export * from "./budgets-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports